export default "__VITE_ASSET__30c3b73d__"